module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1203.6396075a.png";